export default "__VITE_ASSET__BWl2qIj9__"